import script from "./Kardex.vue?vue&type=script&setup=true&lang=js"
export * from "./Kardex.vue?vue&type=script&setup=true&lang=js"

import "./Kardex.vue?vue&type=style&index=0&id=5b296915&lang=css"

const __exports__ = script;

export default __exports__